import React from 'react';
import ReactDOM from 'react-dom/client';
import ConversionTool from './ConversionTool';
import { ConversionProvider } from './ConversionContext';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-conversion-tool',
);

if ($root) {
	ReactDOM.createRoot($root).render(
		<React.StrictMode>
			<ConversionProvider>
				<ConversionTool />
			</ConversionProvider>
		</React.StrictMode>
	);
}
